export default "__VITE_ASSET__BSWA2jtj__"